import {
    getIsApiPending,
    getQuoteForm,
    getPlanValue,
    getSegmentValue,
    getSectionValue,
    getPremiumCalculation,
    getCountries,
} from '../../../selectors/travelKe/quote';
import {
    apiTransitionTravelInsuranceQuoteForm,
    calculateTravelInsurancePremiumSuccess,
} from '../../../actions/travelKe/quote';
import { setPersonalDetailIdValue } from '../../../actions/travelKe/personalDetails';
import { getAccessToken } from '../../../selectors/travelKe/payments';
import axios from 'axios';
import { getAgentForm } from '../../../selectors/travelKe/travelAgentModal';

export const premiumCalculationService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionTravelInsuranceQuoteForm.pending());
            try {
                const resp = await calculate(store.getState());

                store.dispatch(calculateTravelInsurancePremiumSuccess(resp.data));
                store.dispatch(setPersonalDetailIdValue(resp.data.id));
                store.dispatch(apiTransitionTravelInsuranceQuoteForm.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionTravelInsuranceQuoteForm.failure());
            }
        }
    })();
    return next(action);
};

function convertDateFormat(dateString) {
    // Split the date string into day, month, and year
    var parts = dateString.split('/');

    // Rearrange the parts into the desired format
    var formattedDate = parts[2] + '-' + parts[1].padStart(2, '0') + '-' + parts[0].padStart(2, '0');

    return formattedDate;
}

export function getCountryName(countryInput) {
    const countryMap = {
        AF: 'Afghanistan',
        AX: 'Åland Islands',
        AL: 'Albania',
        DZ: 'Algeria',
        AS: 'American Samoa',
        AD: 'Andorra',
        AO: 'Angola',
        AI: 'Anguilla',
        AQ: 'Antarctica',
        AG: 'Antigua and Barbuda',
        AR: 'Argentina',
        AM: 'Armenia',
        AW: 'Aruba',
        AU: 'Australia',
        AT: 'Austria',
        AZ: 'Azerbaijan',
        BS: 'Bahamas',
        BH: 'Bahrain',
        BD: 'Bangladesh',
        BB: 'Barbados',
        BY: 'Belarus',
        BE: 'Belgium',
        BZ: 'Belize',
        BJ: 'Benin',
        BM: 'Bermuda',
        BT: 'Bhutan',
        BO: 'Bolivia',
        BQ: 'Bonaire, Sint Eustatius and Saba',
        BA: 'Bosnia and Herzegovina',
        BW: 'Botswana',
        BV: 'Bouvet Island',
        BR: 'Brazil',
        IO: 'British Indian Ocean Territory',
        BN: 'Brunei Darussalam',
        BG: 'Bulgaria',
        BF: 'Burkina Faso',
        BI: 'Burundi',
        CV: 'Cabo Verde',
        KH: 'Cambodia',
        CM: 'Cameroon',
        CA: 'Canada',
        KY: 'Cayman Islands',
        CF: 'Central African Republic',
        TD: 'Chad',
        CL: 'Chile',
        CN: 'China',
        CX: 'Christmas Island',
        CC: 'Cocos (Keeling) Islands',
        CO: 'Colombia',
        KM: 'Comoros',
        CG: 'Congo',
        CD: 'Congo, Democratic Republic of the',
        CK: 'Cook Islands',
        CR: 'Costa Rica',
        CI: "Côte d'Ivoire",
        HR: 'Croatia',
        CU: 'Cuba',
        CW: 'Curaçao',
        CY: 'Cyprus',
        CZ: 'Czech Republic',
        DK: 'Denmark',
        DJ: 'Djibouti',
        DM: 'Dominica',
        DO: 'Dominican Republic',
        EC: 'Ecuador',
        EG: 'Egypt',
        SV: 'El Salvador',
        GQ: 'Equatorial Guinea',
        ER: 'Eritrea',
        EE: 'Estonia',
        SZ: 'Eswatini',
        ET: 'Ethiopia',
        FK: 'Falkland Islands (Malvinas)',
        FO: 'Faroe Islands',
        FJ: 'Fiji',
        FI: 'Finland',
        FR: 'France',
        GF: 'French Guiana',
        PF: 'French Polynesia',
        TF: 'French Southern Territories',
        GA: 'Gabon',
        GM: 'Gambia',
        GE: 'Georgia',
        DE: 'Germany',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GR: 'Greece',
        GL: 'Greenland',
        GD: 'Grenada',
        GP: 'Guadeloupe',
        GU: 'Guam',
        GT: 'Guatemala',
        GG: 'Guernsey',
        GN: 'Guinea',
        GW: 'Guinea-Bissau',
        GY: 'Guyana',
        HT: 'Haiti',
        HM: 'Heard Island and McDonald Islands',
        VA: 'Holy See',
        HN: 'Honduras',
        HK: 'Hong Kong',
        HU: 'Hungary',
        IS: 'Iceland',
        IN: 'India',
        ID: 'Indonesia',
        IR: 'Iran',
        IQ: 'Iraq',
        IE: 'Ireland',
        IM: 'Isle of Man',
        IM: 'Isle of Man',
        IL: 'Israel',
        IT: 'Italy',
        JM: 'Jamaica',
        JP: 'Japan',
        JE: 'Jersey',
        JO: 'Jordan',
        KZ: 'Kazakhstan',
        KE: 'Kenya',
        KI: 'Kiribati',
        KP: 'North Korea',
        KR: 'South Korea',
        KW: 'Kuwait',
        KG: 'Kyrgyzstan',
        LA: 'Laos',
        LV: 'Latvia',
        LB: 'Lebanon',
        LS: 'Lesotho',
        LR: 'Liberia',
        LY: 'Libya',
        LI: 'Liechtenstein',
        LT: 'Lithuania',
        LU: 'Luxembourg',
        MO: 'Macao',
        MG: 'Madagascar',
        MW: 'Malawi',
        MY: 'Malaysia',
        MV: 'Maldives',
        ML: 'Mali',
        MT: 'Malta',
        MH: 'Marshall Islands',
        MQ: 'Martinique',
        MR: 'Mauritania',
        MU: 'Mauritius',
        YT: 'Mayotte',
        MX: 'Mexico',
        FM: 'Micronesia',
        MD: 'Moldova',
        MC: 'Monaco',
        MN: 'Mongolia',
        ME: 'Montenegro',
        MS: 'Montserrat',
        MA: 'Morocco',
        MZ: 'Mozambique',
        MM: 'Myanmar',
        NA: 'Namibia',
        NR: 'Nauru',
        NP: 'Nepal',
        NL: 'Netherlands',
        NC: 'New Caledonia',
        NZ: 'New Zealand',
        NI: 'Nicaragua',
        NE: 'Niger',
        NG: 'Nigeria',
        NU: 'Niue',
        NF: 'Norfolk Island',
        MK: 'North Macedonia',
        MP: 'Northern Mariana Islands',
        NO: 'Norway',
        OM: 'Oman',
        PK: 'Pakistan',
        PW: 'Palau',
        PS: 'Palestine',
        PA: 'Panama',
        PG: 'Papua New Guinea',
        PY: 'Paraguay',
        PE: 'Peru',
        PH: 'Philippines',
        PN: 'Pitcairn',
        PL: 'Poland',
        PT: 'Portugal',
        PR: 'Puerto Rico',
        QA: 'Qatar',
        RE: 'Réunion',
        RO: 'Romania',
        RU: 'Russia',
        RW: 'Rwanda',
        BL: 'Saint Barthélemy',
        SH: 'Saint Helena, Ascension and Tristan da Cunha',
        KN: 'Saint Kitts and Nevis',
        LC: 'Saint Lucia',
        MF: 'Saint Martin (French part)',
        PM: 'Saint Pierre and Miquelon',
        VC: 'Saint Vincent and the Grenadines',
        WS: 'Samoa',
        SM: 'San Marino',
        ST: 'Sao Tome and Principe',
        SA: 'Saudi Arabia',
        SN: 'Senegal',
        RS: 'Serbia',
        SC: 'Seychelles',
        SL: 'Sierra Leone',
        SG: 'Singapore',
        SX: 'Sint Maarten (Dutch part)',
        SK: 'Slovakia',
        SI: 'Slovenia',
        SB: 'Solomon Islands',
        SO: 'Somalia',
        ZA: 'South Africa',
        GS: 'South Georgia and the South Sandwich Islands',
        SS: 'South Sudan',
        ES: 'Spain',
        LK: 'Sri Lanka',
        SD: 'Sudan',
        SR: 'Suriname',
        SJ: 'Svalbard and Jan Mayen',
        SE: 'Sweden',
        CH: 'Switzerland',
        SY: 'Syria',
        TW: 'Taiwan',
        TJ: 'Tajikistan',
        TZ: 'Tanzania',
        TH: 'Thailand',
        TL: 'Timor-Leste',
        TG: 'Togo',
        TK: 'Tokelau',
        TO: 'Tonga',
        TT: 'Trinidad and Tobago',
        TN: 'Tunisia',
        TR: 'Turkey',
        TM: 'Turkmenistan',
        TC: 'Turks and Caicos Islands',
        TV: 'Tuvalu',
        UG: 'Uganda',
        UA: 'Ukraine',
        AE: 'United Arab Emirates',
        GB: 'United Kingdom',
        US: 'United States',
        UM: 'United States Minor Outlying Islands',
        UY: 'Uruguay',
        UZ: 'Uzbekistan',
        VU: 'Vanuatu',
        VE: 'Venezuela',
        VN: 'Vietnam',
        VG: 'British Virgin Islands',
        VI: 'U.S. Virgin Islands',
        WF: 'Wallis and Futuna',
        EH: 'Western Sahara',
        YE: 'Yemen',
        ZM: 'Zambia',
        ZW: 'Zimbabwe',
    };

    const uppercaseCountryInput = countryInput?.toUpperCase();

    return countryMap[uppercaseCountryInput] ?? 'Unknown';
}

export function filterEuropeCountries(countries) {
    const europeanCountries = [
        'albania',
        'andorra',
        'armenia',
        'austria',
        'azerbaijan',
        'belarus',
        'belgium',
        'bosnia and herzegovina',
        'bulgaria',
        'croatia',
        'cyprus',
        'czechia',
        'denmark',
        'estonia',
        'finland',
        'france',
        'georgia',
        'germany',
        'greece',
        'hungary',
        'iceland',
        'ireland',
        'italy',
        'kazakhstan',
        'kosovo',
        'latvia',
        'liechtenstein',
        'lithuania',
        'luxembourg',
        'malta',
        'moldova',
        'monaco',
        'montenegro',
        'netherlands',
        'north macedonia',
        'norway',
        'poland',
        'portugal',
        'romania',
        'russia',
        'san marino',
        'serbia',
        'slovakia',
        'slovenia',
        'spain',
        'sweden',
        'switzerland',
        'ukraine',
        'united kingdom',
        'vatican city',
        // turkey added to list to prevent pilgrimage users from selecting it since they cannot access the worldwide benefits table
        'turkey',
    ];

    const europeanCountriesSet = new Set(europeanCountries);

    return countries.filter((country) => {
        const countryNameLower = country.name.toLowerCase();
        return !europeanCountriesSet.has(countryNameLower);
    });
}

function getCountryISOCode(countryInput) {
    const countries = {
        afghanistan: 'AF',
        albania: 'AL',
        algeria: 'DZ',
        ['american samoa']: 'AS',
        andorra: 'AD',
        angola: 'AO',
        anguilla: 'AI',
        antarctica: 'AQ',
        ['antigua and barbuda']: 'AG',
        argentina: 'AR',
        armenia: 'AM',
        aruba: 'AW',
        australia: 'AU',
        austria: 'AT',
        azerbaijan: 'AZ',
        ['bahamas (the)']: 'BS',
        bahrain: 'BH',
        bangladesh: 'BD',
        barbados: 'BB',
        belarus: 'BY',
        belgium: 'BE',
        belize: 'BZ',
        benin: 'BJ',
        bermuda: 'BM',
        bhutan: 'BT',
        ['bolivia (plurinational state of)']: 'BO',
        ['bonaire, sint eustatius and saba']: 'BQ',
        ['bosnia and herzegovina']: 'BA',
        botswana: 'BW',
        ['bouvet island']: 'BV',
        brazil: 'BR',
        ['british indian ocean territory (the)']: 'IO',
        ['brunei darussalam']: 'BN',
        bulgaria: 'BG',
        ['burkina faso']: 'BF',
        burundi: 'BI',
        ['cabo verde']: 'CV',
        cambodia: 'KH',
        cameroon: 'CM',
        canada: 'CA',
        ['cayman islands (the)']: 'KY',
        ['central african republic (the)']: 'CF',
        chad: 'TD',
        chile: 'CL',
        china: 'CN',
        ['christmas island']: 'CX',
        ['cocos (keeling) islands (the)']: 'CC',
        colombia: 'CO',
        ['comoros (the)']: 'KM',
        ['congo (the democratic republic of the)']: 'CD',
        ['congo (the)']: 'CG',
        ['cook islands (the)']: 'CK',
        ['costa rica']: 'CR',
        croatia: 'HR',
        cuba: 'CU',
        curaçao: 'CW',
        cyprus: 'CY',
        czechia: 'CZ',
        ["côte d'ivoire"]: 'CI',
        denmark: 'DK',
        djibouti: 'DJ',
        dominica: 'DM',
        ['dominican republic (the)']: 'DO',
        ecuador: 'EC',
        egypt: 'EG',
        ['el salvador']: 'SV',
        ['equatorial guinea']: 'GQ',
        eritrea: 'ER',
        estonia: 'EE',
        eswatini: 'SZ',
        ethiopia: 'ET',
        ['falkland islands (the) [malvinas]']: 'FK',
        ['faroe islands (the)']: 'FO',
        fiji: 'FJ',
        finland: 'FI',
        france: 'FR',
        ['french guiana']: 'GF',
        ['french polynesia']: 'PF',
        ['french southern territories (the)']: 'TF',
        gabon: 'GA',
        ['gambia (the)']: 'GM',
        georgia: 'GE',
        germany: 'DE',
        ghana: 'GH',
        gibraltar: 'GI',
        greece: 'GR',
        greenland: 'GL',
        grenada: 'GD',
        guadeloupe: 'GP',
        guam: 'GU',
        guatemala: 'GT',
        guernsey: 'GG',
        guinea: 'GN',
        ['guinea-bissau']: 'GW',
        guyana: 'GY',
        haiti: 'HT',
        ['heard island and mcdonald islands']: 'HM',
        ['holy see (the)']: 'VA',
        honduras: 'HN',
        ['hong kong']: 'HK',
        hungary: 'HU',
        iceland: 'IS',
        india: 'IN',
        indonesia: 'ID',
        ['iran (islamic republic of)']: 'IR',
        iraq: 'IQ',
        ireland: 'IE',
        ['isle of man']: 'IM',
        israel: 'IL',
        italy: 'IT',
        jamaica: 'JM',
        japan: 'JP',
        jersey: 'JE',
        jordan: 'JO',
        kazakhstan: 'KZ',
        kenya: 'KE',
        kiribati: 'KI',
        ["korea (the democratic people's republic of)"]: 'KP',
        ['korea (the republic of)']: 'KR',
        kuwait: 'KW',
        kyrgyzstan: 'KG',
        ["lao people's democratic republic (the)"]: 'LA',
        latvia: 'LV',
        lebanon: 'LB',
        lesotho: 'LS',
        liberia: 'LR',
        libya: 'LY',
        liechtenstein: 'LI',
        lithuania: 'LT',
        luxembourg: 'LU',
        macao: 'MO',
        madagascar: 'MG',
        malawi: 'MW',
        malaysia: 'MY',
        maldives: 'MV',
        mali: 'ML',
        malta: 'MT',
        ['marshall islands (the)']: 'MH',
        martinique: 'MQ',
        mauritania: 'MR',
        mauritius: 'MU',
        mayotte: 'YT',
        mexico: 'MX',
        ['micronesia (federated states of)']: 'FM',
        ['moldova (the republic of)']: 'MD',
        monaco: 'MC',
        mongolia: 'MN',
        montenegro: 'ME',
        montserrat: 'MS',
        morocco: 'MA',
        mozambique: 'MZ',
        myanmar: 'MM',
        namibia: 'NA',
        nauru: 'NR',
        nepal: 'NP',
        ['netherlands (the)']: 'NL',
        ['new caledonia']: 'NC',
        ['new zealand']: 'NZ',
        nicaragua: 'NI',
        'niger (the)': 'NE',
        nigeria: 'NG',
        niue: 'NU',
        ['norfolk island']: 'NF',
        ['northern mariana islands (the)']: 'MP',
        norway: 'NO',
        oman: 'OM',
        pakistan: 'PK',
        palau: 'PW',
        ['palestine, state of']: 'PS',
        panama: 'PA',
        ['papua new guinea']: 'PG',
        paraguay: 'PY',
        peru: 'PE',
        ['philippines (the)']: 'PH',
        pitcairn: 'PN',
        poland: 'PL',
        portugal: 'PT',
        ['puerto rico']: 'PR',
        qatar: 'QA',
        ['republic of north macedonia']: 'MK',
        romania: 'RO',
        ['russian federation (the)']: 'RU',
        rwanda: 'RW',
        réunion: 'RE',
        ['saint barthélemy']: 'BL',
        'saint helena, ascension and tristan da cunha': 'SH',
        ['saint kitts and nevis']: 'KN',
        ['saint lucia']: 'LC',
        ['saint martin (french part)']: 'MF',
        ['saint pierre and miquelon']: 'PM',
        ['saint vincent and the grenadines']: 'VC',
        samoa: 'WS',
        ['san marino']: 'SM',
        ['sao tome and principe']: 'ST',
        ['saudi arabia']: 'SA',
        senegal: 'SN',
        serbia: 'RS',
        seychelles: 'SC',
        ['sierra leone']: 'SL',
        singapore: 'SG',
        ['sint maarten (dutch part)']: 'SX',
        slovakia: 'SK',
        slovenia: 'SI',
        ['solomon islands']: 'SB',
        somalia: 'SO',
        ['south africa']: 'ZA',
        ['south georgia and the south sandwich islands']: 'GS',
        ['south sudan']: 'SS',
        spain: 'ES',
        ['sri lanka']: 'LK',
        ['sudan (the)']: 'SD',
        suriname: 'SR',
        ['svalbard and jan mayen']: 'SJ',
        sweden: 'SE',
        switzerland: 'CH',
        ['syrian arab republic']: 'SY',
        taiwan: 'TW',
        tajikistan: 'TJ',
        ['tanzania, united republic of']: 'TZ',
        thailand: 'TH',
        ['timor-leste']: 'TL',
        togo: 'TG',
        tokelau: 'TK',
        tonga: 'TO',
        ['trinidad and tobago']: 'TT',
        tunisia: 'TN',
        turkey: 'TR',
        turkmenistan: 'TM',
        ['turks and caicos islands (the)']: 'TC',
        tuvalu: 'TV',
        uganda: 'UG',
        ukraine: 'UA',
        ['united arab emirates (the)']: 'AE',
        ['united kingdom of great britain and northern ireland (the)']: 'GB',
        ['united states minor outlying islands (the)']: 'UM',
        ['united states of america (the)']: 'US',
        uruguay: 'UY',
        uzbekistan: 'UZ',
        vanuatu: 'VU',
        ['venezuela (bolivarian republic of)']: 'VE',
        ['viet nam']: 'VN',
        ['virgin islands (british)']: 'VG',
        ['virgin islands (u.s.)']: 'VI',
        ['wallis and futuna']: 'WF',
        ['western sahara']: 'EH',
        yemen: 'YE',
        zambia: 'ZM',
        zimbabwe: 'ZW',
        ['åland islands']: 'AX',
    };

    if (!Array.isArray(countryInput) && typeof countryInput === 'string') {
        return countries[countryInput.toLowerCase()];
    }

    const countryCodes = countryInput?.map((country) => {
        const countryCode = countries[country.toLowerCase()];

        return countryCode ? countryCode : null;
    });

    return countryCodes?.filter((code) => code !== null);
}

export function getContinent(countryInput) {
    const continentMap = {
        AFGHANISTAN: 'Asia',
        ['ÅLAND ISLANDS']: 'Europe',
        ALBANIA: 'Europe',
        ALGERIA: 'Africa',
        ['AMERICAN SAMOA']: 'Oceania',
        ANDORRA: 'Europe',
        ANGOLA: 'Africa',
        ANGUILLA: 'North America',
        ANTARCTICA: 'Antarctica',
        ['ANTIGUA AND BARBUDA']: 'North America',
        ARGENTINA: 'South America',
        ARMENIA: 'Asia',
        ARUBA: 'North America',
        AUSTRALIA: 'Oceania',
        AUSTRIA: 'Europe',
        AZERBAIJAN: 'Asia',
        BAHAMAS: 'North America',
        BAHRAIN: 'Asia',
        BANGLADESH: 'Asia',
        BARBADOS: 'North America',
        BELARUS: 'Europe',
        BELGIUM: 'Europe',
        BELIZE: 'North America',
        BENIN: 'Africa',
        BERMUDA: 'North America',
        BHUTAN: 'Asia',
        ['BOLIVIA (PLURINATIONAL STATE OF)']: 'South America',
        ['BONAIRE, SINT EUSTATIUS AND SABA']: 'North America',
        ['BOSNIA AND HERZEGOVINA']: 'Europe',
        BOTSWANA: 'Africa',
        ['BOUVET ISLAND']: 'Antarctica',
        BRAZIL: 'South America',
        ['BRITISH INDIAN OCEAN TERRITORY']: 'Asia',
        ['BRUNEI DARUSSALAM']: 'Asia',
        BULGARIA: 'Europe',
        ['BURKINA FASO']: 'Africa',
        BURUNDI: 'Africa',
        ['CABO VERDE']: 'Africa',
        CAMBODIA: 'Asia',
        CAMEROON: 'Africa',
        CANADA: 'North America',
        ['CAYMAN ISLANDS']: 'North America',
        ['CENTRAL AFRICAN REPUBLIC']: 'Africa',
        CHAD: 'Africa',
        CHILE: 'South America',
        CHINA: 'Asia',
        ['CHRISTMAS ISLAND']: 'Asia',
        ['COCOS (KEELING) ISLANDS']: 'Asia',
        COLOMBIA: 'South America',
        COMOROS: 'Africa',
        CONGO: 'Africa',
        ['CONGO, DEMOCRATIC REPUBLIC OF THE']: 'Africa',
        ['COOK ISLANDS']: 'Oceania',
        ['COSTA RICA']: 'North America',
        ["CÔTE D'IVOIRE"]: 'Africa',
        CROATIA: 'Europe',
        CUBA: 'North America',
        CURAÇAO: 'North America',
        CYPRUS: 'Asia',
        CZECHIA: 'Europe',
        DENMARK: 'Europe',
        DJIBOUTI: 'Africa',
        DOMINICA: 'North America',
        ['DOMINICAN REPUBLIC']: 'North America',
        ECUADOR: 'South America',
        EGYPT: 'Africa',
        ['EL SALVADOR']: 'North America',
        ['EQUATORIAL GUINEA']: 'Africa',
        ERITREA: 'Africa',
        ESTONIA: 'Europe',
        ESWATINI: 'Africa',
        ETHIOPIA: 'Africa',
        ['FALKLAND ISLANDS (MALVINAS)']: 'South America',
        ['FAROE ISLANDS']: 'Europe',
        FIJI: 'Oceania',
        FINLAND: 'Europe',
        FRANCE: 'Europe',
        ['FRENCH GUIANA']: 'South America',
        ['FRENCH POLYNESIA']: 'Oceania',
        ['FRENCH SOUTHERN TERRITORIES']: 'Antarctica',
        GABON: 'Africa',
        GAMBIA: 'Africa',
        GEORGIA: 'Asia',
        GERMANY: 'Europe',
        GHANA: 'Africa',
        GIBRALTAR: 'Europe',
        GREECE: 'Europe',
        GREENLAND: 'North America',
        GRENADA: 'North America',
        GUADELOUPE: 'North America',
        GUAM: 'Oceania',
        GUATEMALA: 'North America',
        GUERNSEY: 'Europe',
        GUINEA: 'Africa',
        ['GUINEA-BISSAU']: 'Africa',
        GUYANA: 'South America',
        HAITI: 'North America',
        ['HEARD ISLAND AND MCDONALD ISLANDS']: 'Antarctica',
        ['HOLY SEE']: 'Europe',
        HONDURAS: 'North America',
        ['HONG KONG']: 'Asia',
        HUNGARY: 'Europe',
        ICELAND: 'Europe',
        INDIA: 'Asia',
        INDONESIA: 'Asia',
        ['IRAN (ISLAMIC REPUBLIC OF)']: 'Asia',
        IRAQ: 'Asia',
        IRELAND: 'Europe',
        ['ISLE OF MAN']: 'Europe',
        ISRAEL: 'Asia',
        ITALY: 'Europe',
        JAMAICA: 'North America',
        JAPAN: 'Asia',
        JERSEY: 'Europe',
        JORDAN: 'Asia',
        KAZAKHSTAN: 'Asia',
        KENYA: 'Africa',
        KIRIBATI: 'Oceania',
        ["KOREA (DEMOCRATIC PEOPLE'S REPUBLIC OF)"]: 'Asia',
        ['KOREA, REPUBLIC OF']: 'Asia',
        KUWAIT: 'Asia',
        KYRGYZSTAN: 'Asia',
        ["LAO PEOPLE'S DEMOCRATIC REPUBLIC"]: 'Asia',
        LATVIA: 'Europe',
        LEBANON: 'Asia',
        LESOTHO: 'Africa',
        LIBERIA: 'Africa',
        LIBYA: 'Africa',
        LIECHTENSTEIN: 'Europe',
        LITHUANIA: 'Europe',
        LUXEMBOURG: 'Europe',
        MACAO: 'Asia',
        MADAGASCAR: 'Africa',
        MALAWI: 'Africa',
        MALAYSIA: 'Asia',
        MALDIVES: 'Asia',
        MALI: 'Africa',
        MALTA: 'Europe',
        ['MARSHALL ISLANDS']: 'Oceania',
        MARTINIQUE: 'North America',
        MAURITANIA: 'Africa',
        MAURITIUS: 'Africa',
        MAYOTTE: 'Africa',
        MEXICO: 'North America',
        ['MICRONESIA (FEDERATED STATES OF)']: 'Oceania',
        ['MOLDOVA, REPUBLIC OF']: 'Europe',
        MONACO: 'Europe',
        MONGOLIA: 'Asia',
        MONTENEGRO: 'Europe',
        MONTSERRAT: 'North America',
        MOROCCO: 'Africa',
        MOZAMBIQUE: 'Africa',
        MYANMAR: 'Asia',
        NAMIBIA: 'Africa',
        NAURU: 'Oceania',
        NEPAL: 'Asia',
        NETHERLANDS: 'Europe',
        ['NEW CALEDONIA']: 'Oceania',
        ['NEW ZEALAND']: 'Oceania',
        NICARAGUA: 'North America',
        NIGER: 'Africa',
        NIGERIA: 'Africa',
        NIUE: 'Oceania',
        ['NORFOLK ISLAND']: 'Oceania',
        ['NORTH MACEDONIA']: 'Europe',
        ['NORTHERN MARIANA ISLANDS']: 'Oceania',
        NORWAY: 'Europe',
        OMAN: 'Asia',
        PAKISTAN: 'Asia',
        PALAU: 'Oceania',
        ['PALESTINE, STATE OF']: 'Asia',
        PANAMA: 'North America',
        ['PAPUA NEW GUINEA']: 'Oceania',
        PARAGUAY: 'South America',
        PERU: 'South America',
        PHILIPPINES: 'Asia',
        PITCAIRN: 'Oceania',
        POLAND: 'Europe',
        PORTUGAL: 'Europe',
        ['PUERTO RICO']: 'North America',
        QATAR: 'Asia',
        RÉUNION: 'Africa',
        ROMANIA: 'Europe',
        ['RUSSIAN FEDERATION']: 'Europe',
        RWANDA: 'Africa',
        ['SAINT BARTHÉLEMY']: 'North America',
        ['SAINT HELENA, ASCENSION AND TRISTAN DA CUNHA']: 'Africa',
        ['SAINT KITTS AND NEVIS']: 'North America',
        ['SAINT LUCIA']: 'North America',
        ['SAINT MARTIN (FRENCH PART)']: 'North America',
        ['SAINT PIERRE AND MIQUELON']: 'North America',
        ['SAINT VINCENT AND THE GRENADINES']: 'North America',
        SAMOA: 'Oceania',
        ['SAN MARINO']: 'Europe',
        ['SAO TOME AND PRINCIPE']: 'Africa',
        ['SAUDI ARABIA']: 'Asia',
        SENEGAL: 'Africa',
        SERBIA: 'Europe',
        SEYCHELLES: 'Africa',
        ['SIERRA LEONE']: 'Africa',
        SINGAPORE: 'Asia',
        ['SINT MAARTEN (DUTCH PART)']: 'North America',
        SLOVAKIA: 'Europe',
        SLOVENIA: 'Europe',
        ['SOLOMON ISLANDS']: 'Oceania',
        SOMALIA: 'Africa',
        ['SOUTH AFRICA']: 'Africa',
        ['SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS']: 'Antarctica',
        ['SOUTH SUDAN']: 'Africa',
        SPAIN: 'Europe',
        ['SRI LANKA']: 'Asia',
        SUDAN: 'Africa',
        SURINAME: 'South America',
        ['SVALBARD AND JAN MAYEN']: 'Europe',
        SWEDEN: 'Europe',
        SWITZERLAND: 'Europe',
        ['SYRIAN ARAB REPUBLIC']: 'Asia',
        ['TAIWAN, PROVINCE OF CHINA']: 'Asia',
        TAJIKISTAN: 'Asia',
        ['TANZANIA, UNITED REPUBLIC OF']: 'Africa',
        THAILAND: 'Asia',
        ['TIMOR-LESTE']: 'Asia',
        TOGO: 'Africa',
        TOKELAU: 'Oceania',
        TONGA: 'Oceania',
        ['TRINIDAD AND TOBAGO']: 'North America',
        TUNISIA: 'Africa',
        // turkey changed to North America because we want users taken to the worldwide table on selecting turkey
        TURKEY: 'North America',
        TURKMENISTAN: 'Asia',
        ['TURKS AND CAICOS ISLANDS']: 'North America',
        TUVALU: 'Oceania',
        UGANDA: 'Africa',
        UKRAINE: 'Europe',
        ['UNITED ARAB EMIRATES']: 'Asia',
        ['UNITED KINGDOM OF GREAT BRITAIN AND NORTHERN IRELAND']: 'Europe',
        ['UNITED STATES MINOR OUTLYING ISLANDS']: 'Oceania',
        ['UNITED STATES OF AMERICA']: 'North America',
        URUGUAY: 'South America',
        UZBEKISTAN: 'Asia',
        VANUATU: 'Oceania',
        ['VENEZUELA (BOLIVARIAN REPUBLIC OF)']: 'South America',
        VIETNAM: 'Asia',
        ['VIRGIN ISLANDS (BRITISH)']: 'North America',
        ['VIRGIN ISLANDS (U.S.)']: 'North America',
        ['WALLIS AND FUTUNA']: 'Oceania',
        ['WESTERN SAHARA']: 'Africa',
        YEMEN: 'Asia',
        ZAMBIA: 'Africa',
        ZIMBABWE: 'Africa',
    };

    if (!Array.isArray(countryInput)) {
        // Normalize input to uppercase
        const input = countryInput?.toUpperCase();

        // Return the continent or "Unknown" if not found
        return continentMap[getCountryName(input).toUpperCase()] || 'Unknown';
    }
    // If the input is an array, return an array of continents
    const continents = countryInput.map((country) => {
        const upperCountry = country?.toUpperCase();
        return continentMap[upperCountry] || 'Unknown';
    });

    return continents;
}

const premiumCalculationPayload = (state) => {
    const quotation = getQuoteForm(state);
    const agent = getAgentForm(state);
    const segment = getSegmentValue(state);
    const countries = getCountries(state);

    const trip = quotation.tripType.value;
    const name = quotation.name.value;
    const email = quotation.email.value;
    const phoneNumber = quotation.phoneNumber.value;
    const who = quotation.coverFor.value;
    const cover = quotation.selectedCover.value;
    const noOfMinors = quotation.noOfMinors.value;
    const noOfAdults = quotation.noOfAdults.value;
    const noOfSeniors = quotation.noOfSeniors.value;
    const noOfSeniors76 = quotation.noOfSeniors76.value;
    const noOfSeniors81 = quotation.noOfSeniors81.value;
    const departureCountry = quotation.departureCountry.value;
    const destinationCountry = quotation.destinationCountry.value;
    const travelStartDate = convertDateFormat(quotation.departureDate.value);
    const travelEndDate = convertDateFormat(quotation.returnDate.value);
    const agentCode = agent.agentCode.value;

    const continent = () => {
        const selectedCountryCode = quotation.destinationCountry.value;
        const countryData = countries.find((country) => country.code === selectedCountryCode);

        return countryData ? countryData.packages[0].package : 'Unknown';
    };

    const planValue = getPlanValue(state);
    const section = getSectionValue(state);
    const plan =
        quotation.selectedCover.value === 'retail'
            ? section === 'quoteScreen'
                ? continent()
                : planValue
            : quotation.selectedCover.value === 'student'
            ? planValue
            : planValue;

    const payload = {
        noOfDaysPerYear: null,
        // trip,
        // who,
        cover,
        plan,
        segment: segment ? segment : 'basic',
        noOfMinors: noOfMinors || 0,
        noOfAdults: noOfAdults || 0,
        noOfSeniors: noOfSeniors || 0,
        noOfSeniors76: noOfSeniors76 || 0,
        noOfSeniors81: noOfSeniors81 || 0,
        departureCountry,
        destinationCountry,
        travelStartDate,
        travelEndDate,
        // referrerId: agentCode,
        name: name,
        email,
        phoneNumber,
    };
    // Change payload here
    return {
        ...payload,
    };
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/travel-ke/compute-premium';
        return await axios.post(url, premiumCalculationPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

// Update travel insurance quote form data
export const premiumCalculcationUpdateService = (store, next, action) => {
    (async () => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionTravelInsuranceQuoteForm.pending());
            try {
                const resp = await update(store.getState());

                store.dispatch(calculateTravelInsurancePremiumSuccess(resp.data));
                store.dispatch(apiTransitionTravelInsuranceQuoteForm.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionTravelInsuranceQuoteForm.failure());
            }
        }
    })();
    return next(action);
};

const premiumUpdatePayload = (state) => {
    const payloadData = getPremiumCalculation(state);
    const quoteId = payloadData?.value?.id;
    const calculatedPayload = premiumCalculationPayload(state);

    return {
        ...calculatedPayload,
        id: quoteId,
    };
};

const update = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/travel-ke/compute-premium';
        return await axios.post(url, premiumUpdatePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
